<template>
  <q-layout view="hHh Lpr lff">
    <side-drawer v-model="leftDrawerOpen" />
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>

import SideDrawer from '../components/SideDrawer.vue'

export default {
  name: 'PrivateLayout',
  components: { SideDrawer },
  data () {
    return {
      leftDrawerOpen: false
    }
  }
}
</script>
